/**
 * OrbDocDownloadsCliENOrbDocDownloadsCliENPage
 *
 * Page component for OrbDocDownloadsCliENOrbDocDownloadsCliENPage
 * Path: /docs/downloads/cli
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocDownloadsCliENDocScreenView as __OrbDocDownloadsCliENDocScreenView } from '@/components/traits/OrbDocDownloadsCliENDocScreenView';
import { OrbDocDownloadsCliENDocAnalyticsView as __OrbDocDownloadsCliENDocAnalyticsView } from '@/components/traits/OrbDocDownloadsCliENDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocDownloadsCliENOrbDocDownloadsCliENPageProps {
  // Add any page-level props here
}

export function OrbDocDownloadsCliENOrbDocDownloadsCliENPage(_props: OrbDocDownloadsCliENOrbDocDownloadsCliENPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"The orb CLI","description":"Every orb command: validate, verify, compile, serve, and the tools around them.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/downloads/cli"},{"locale":"ar","path":"/ar/docs/downloads/cli"},{"locale":"sl","path":"/sl/docs/downloads/cli"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocDownloadsCliENDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocDownloadsCliENDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocDownloadsCliENOrbDocDownloadsCliENPage;
